// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-info-canva{
    background-color: rgba(37, 37, 37, 0.9);
}

.item-info-canva .title{
    font-family: 'Milonga', serif;
    font-size: 2em;
}

.item-info-canva img{
    height: 10rem;
}

.item-info-canva .item-name{
    font-family: 'Ubuntu Mono';
    font-size: 2em;
}

.item-info-canva .slot{
    background-color: rgb(100, 100, 100);
    box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;    
    border-radius: 0.2rem;
    font-family: 'Ubuntu Mono';
}

.item-info-canva .tag{
    width: 5rem;
}

.item-info-canva .item-links{
    font-size: 2.5em;
}

.item-info-canva .item-slot{
    font-size: 1.5em;
}

.item-info-canva .item-price{
    font-size: 1.5em;
}

.item-info-canva .rarity-name{
    font-family: 'Ubuntu Mono';
    font-size: 1.5em;
}

.item-info-canva .hero-name{
    font-size: 1.5em;
}

.item-info-canva .rarity{
    border-radius: 0.2rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/ItemInfoCanva.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;AAC3C;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,2TAA2T;IAC3T,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;AACzB","sourcesContent":[".item-info-canva{\n    background-color: rgba(37, 37, 37, 0.9);\n}\n\n.item-info-canva .title{\n    font-family: 'Milonga', serif;\n    font-size: 2em;\n}\n\n.item-info-canva img{\n    height: 10rem;\n}\n\n.item-info-canva .item-name{\n    font-family: 'Ubuntu Mono';\n    font-size: 2em;\n}\n\n.item-info-canva .slot{\n    background-color: rgb(100, 100, 100);\n    box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;    \n    border-radius: 0.2rem;\n    font-family: 'Ubuntu Mono';\n}\n\n.item-info-canva .tag{\n    width: 5rem;\n}\n\n.item-info-canva .item-links{\n    font-size: 2.5em;\n}\n\n.item-info-canva .item-slot{\n    font-size: 1.5em;\n}\n\n.item-info-canva .item-price{\n    font-size: 1.5em;\n}\n\n.item-info-canva .rarity-name{\n    font-family: 'Ubuntu Mono';\n    font-size: 1.5em;\n}\n\n.item-info-canva .hero-name{\n    font-size: 1.5em;\n}\n\n.item-info-canva .rarity{\n    border-radius: 0.2rem;\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
